// extracted by mini-css-extract-plugin
module.exports = {"container":"DonorsListCard_container__1w9IF","infoArea":"DonorsListCard_infoArea__2TNcB","row":"DonorsListCard_row__3EjaA","col":"DonorsListCard_col__2k0TF"};